import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/tokens.css';
import './styles/global.css';
import './styles/homepage.css';
import './styles/start-flow.css';
import './styles/upload-flow.css';
import './styles/draft-flow.css';
import './styles/editor-flow.css';
import './styles/preflight-flow.css';
import './styles/print-preview.css';
import './styles/projects-dashboard.css';
import './styles/order-flow.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
